import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, Renderer, TemplateRef } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Pagination } from '../../../models/pagination';
import { Producto } from '../../../models/producto';
import { ProductoService } from '../../../services/producto.service';
import { Subscription } from "rxjs/Subscription";
import { Categoria } from '../../../models/categoria';
import { Marca } from '../../../models/marca';
import { MarcaService } from '../../../services/marca.service';
import { CategoriaService } from '../../../services/categoria.service';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-producto-modal',
	templateUrl: './producto-modal.component.html',
	styleUrls: ['./producto-modal.component.css'],
	providers: [ProductoService, CategoriaService, MarcaService]
})
export class ProductoModalComponent implements OnInit, OnDestroy {
	@Output() sendObject = new EventEmitter();
	@Input() qs: String = "";
	@Input() if_uso_lote:boolean;
	public title: String;
	public productos: Array<Producto> = [];
	public selectedRow: Number;
	private producto: Producto;
	public pagination: Pagination;
	public loading = false;
	private _modelSubscription: Subscription;
	
	public categorias: Array<Categoria>;
	public categoria: Categoria;
	public marcas: Array<Marca>;
	public marca: Marca;
	public busqueda: String;
	public text: String;
	constructor(
		public productoService: ProductoService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		private modalService: BsModalService,
		public categoriaService: CategoriaService,
   		private marcaService: MarcaService,
	) {
		this.title = "Productos";
		this.pagination = new Pagination();
		this.busqueda = "";
		this.categorias = [];
		this.marcas = [];
		this.categoria = new Categoria();
		this.marca = new Marca();
		this.text = "";
	}

	ngOnInit() {
		
		let p1 = this.getProductos();
		let p2 = this.getCategorias();
		let p3 = this.getMarcas();
		Promise.all([p1,p2,p3]).then(
		res => this.loading = false,
		err => this.loading = false
		);
		// this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
		// 	this.getProductos();
		// });
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getCategorias() {
		return new Promise((resolve, reject) => {
		  this.categoriaService.getAll().subscribe(
			res => {
			  if (res.data.length) {
				this.categorias = res.data;
			  } else {
				this.categorias = [];
			  }
			  resolve(true);
			},
			err => {
			  this.categorias = [];
			  reject();
			}
		  );
		});
	  }

	getMarcas() {
		return new Promise((resolve,reject)=>{
		  this.marcaService.getAll().subscribe(
			res => {
			  this.marcas = res.data;
			  resolve(true);
			},
			err => {
			  reject();
			  this.marcas = [];
			  
			}
		  );
		})
			
	}

	getProductosBySearch(text: string = ''){
		text = text.trim();
		let qs = this.getQs(text);
		
		// this.pagination.current_page = 1;
		this.pagination = new Pagination();
		this.getProductos(qs);
	}

	getQs(text: string = ''){
		let qs = "";
		if(this.categoria.id){
			qs += "&categoria_id=" + this.categoria.id;
		}
		if(this.marca.id){
			qs += "&marca_id=" + this.marca.id; 
		}
			this.busqueda = text;
		if(this.busqueda){
			qs += "&q[producto.codigo]=" + this.busqueda + "&q[producto.nombre]=" + this.busqueda + "&q[producto.descripcion]=" + this.busqueda;
		}
		return qs;
	}

	getProductos(qs = "") {
		let if_uso_lote = '';
		if (this.if_uso_lote) {
			if_uso_lote = '&if_uso_lote=1';
		}else if(this.if_uso_lote == false){
			if_uso_lote = '&if_uso_lote=0';
		}
		this.loading = true;
		this.productoService.getAll('?page='+this.pagination.current_page+'&per_page=10&embed=categoria,unidadmedida,inventario' + this.qs + qs+if_uso_lote).subscribe(
			res => {
				this.loading = false;
				this.productos = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.productos = [];
			}
		);
	}

	next(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page++;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	prev(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page--;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	first(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = 1;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	last(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = this.pagination.last_page;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	onSelectRow(producto, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de producto
		this.producto = producto;
	}

	onDBLClick(proveedor,i)
	{
		this.onSelectRow(proveedor,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto producto
		this.sendObject.emit(this.producto);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	openModal(template: TemplateRef<any>){
		this.bsModalRef2 = this.modalService.show(template, {class: 'second'});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/producto-modal/producto-modal.component.ts